import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IonItemSliding} from '@ionic/angular';

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})
export class OurlyTransactionComponent implements OnInit {

  @Input() slidingEnabled = true;
  @Input() transaction: any;
  @Input() disabled: false;
  @Input() authorizeMode = false;
  @Input() homePage = false;
  @Input() currentTeam
  @Output() reimburseEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() approveDeclineEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  recurrenceTypeLabel(transaction) {
    switch (transaction.recurrenceType) {
      case 'daily':
        return 'Daily';
      case 'weekly':
        return 'Weekly';
      case 'every-other-week':
        return 'Every Other Week';
      case 'every-two-weeks':
        return 'Every Two Weeks';
      case'monthly':
        return 'Monthly';
      case'quarterly':
        return 'Quarterly';
      case'annually':
        return 'Annually';
    }
  }

  reimburseClicked(event) {
    event.stopPropagation();
    this.reimburseEvent.emit(event.detail.value);
  }

  setApprove(sliding?: IonItemSliding) {
    this.approveDeclineEvent.emit(true);
    sliding?.close();
  }

  setDecline(sliding: IonItemSliding) {
    this.approveDeclineEvent.emit(false);
    sliding.close();
  }
}

